import { render } from "./ManageResource.vue?vue&type=template&id=880ee1da"
import script from "./ManageResource.vue?vue&type=script&lang=js"
export * from "./ManageResource.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__